<template>
  <nav class="navbar navbar-expand navbar-white navbar-light">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item ">
        <router-link to="/home" class="nav-link p-2"><i class="fas fa-home"></i></router-link>
      </li>

      <!--            <li class="nav-item" v-if="$route.meta.parent">-->
      <!--                <router-link class="nav-link" :to="$route.meta.parent"><i class="fal fa-lg fa-arrow-circle-left"-->
      <!--                                                                          title="Quay lại"></i></router-link>-->
      <!--            </li>-->
      <li class="nav-item">
        <a class="nav-link p2">Xin chào, <b style="color:#0F172A">{{ user.full_name }}!</b></a>
        <!--                <a class="nav-link" id="app_title"><slot name="title"></slot></a>-->
      </li>
    </ul>
    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      <li class="nav-item dropdown">
        <a class="nav-link py-0" data-toggle="dropdown" href="#" aria-expanded="true">
          <div style="width: 34px; height: 34px">
            <img :src="user.avatar" alt="User Avatar" style="height: 100%; width: 100%" class="mr-3 img-circle">
          </div>
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" style="left: inherit; right: 0; border-radius: 16px">
          <a href="#" class="dropdown-item">
            <div class="media">
              <img :src="user.avatar" alt="User Avatar" class="img-size-50 mr-3 img-circle">
              <div class="media-body">
                <h3 class="dropdown-item-title">
                  {{ user.full_name }}
                </h3>
                <p class="text-sm">{{ user.asgl_id }}</p>
              </div>
            </div>

          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item text-right">
            <button type="button" @click="$auth.logout()" class="btn btn-danger">Đăng xuất</button>
          </a>
        </div>
      </li>
    </ul>
  </nav>
</template>

<script>

export default {
  name: 'NavBar',

  data() {
    return {
      user: {
        full_name: '',
        asgl_id: '',
        avatar: require('@/assets/images/logo.png')
      }
    }
  },
  mounted() {
    this.user = this.$auth.user()
    console.log(this.$auth.user());
  },
  methods: {
    logout() {
      this.$auth.logout();
    },
  }
}
</script>
<style scoped>
.btn-nav svg {
  display: none
}

.btn-nav.active svg {
  display: inline;
  margin-bottom: 3px;
}

.btn-nav {
  color: #F15A22;
  font-weight: 600;
}

.btn-nav.active {
  color: #fff;
}
</style>
